import React, { useState, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal'
import ErrorAlert from '../Alerts/ErrorAlert';
import LoadingAlert from '../Alerts/LoadingAlert';
import Swal from 'sweetalert2';


function ModalWarehouses({ show, setShow, warehouses, setWarehouseSelected }) {

    const [eventHandler, setEventHandler] = useState(0);

    // Function to save the selected warehouse in localStorage and update the state
    const saveWarehouse = (warehouse) => {
        localStorage.setItem('warehouse', JSON.stringify(warehouse));
        Swal.fire({
            icon: 'success',
            title: 'Bodega seleccionada',
            text: `Bodega ${warehouse.name} seleccionada correctamente.`,
            showConfirmButton: true,
            timer: 5000
        });
        setWarehouseSelected(warehouse);
        setEventHandler(1)
        setShow(false);
        updatePage()
    }


    // Function to update the page after selecting a warehouse
    const updatePage = () => {
        window.location.reload()
    }


    useEffect(() => { setEventHandler(0) }, [eventHandler]);
    return (
        <>
            <Modal
                show={false}
                size="xl"
                centered
                onHide={() => setShow(false)}
            >
                <Modal.Body >
                    <div className="d-flex justify-content-center border-bottom-0">
                        <h1 className="modal-title fw-bold fs-5">
                            <i class="uil uil-database-alt"></i>
                            Bodegas
                        </h1>
                    </div>

                    <p className='p-0  text-primary fw-bold my-1'>Listado de Bodegas  </p>
                    <div className={" item2  border border-0  rounded-3 list-framer-stocks  no-scroll bg-light"}>
                        <div className='row p-lg-4 p-1'>
                            <div className="col-md-3" onClick={() => saveWarehouse({ name: "Selecciona una bodega", id: 0 })} >
                                <div className="card border-0 shadow-sm rounded-sp ">

                                    <div className="card-body">
                                        <h5 className="card-title text-center fw-bold text-truncate text-dark">Sin bodega</h5>
                                    </div>
                                </div>
                            </div>
                            {warehouses.map((warehouse) => (<>
                                <div className="col-md-3" onClick={() => saveWarehouse(warehouse)} >
                                    <div className="card border-0 shadow-sm rounded-sp ">

                                        <div className="card-body">
                                            <h5 className="card-title text-center fw-bold text-truncate text-dark"> {warehouse.name}</h5>
                                        </div>


                                    </div>
                                </div></>))}
                        </div>
                    </div>
                    <div className='d-flex justify-content-center alight-item-center '><small className='text-body-tertiary text-center mt-3'>
                        <i className="uil uil-info-circle me-1"></i>
                        Por favor, Seleccione una bodega
                    </small></div>


                    <div className='flex-container'>


                        <div className='d-block mt-lg-1 mt-0'>
                            <div className='d-flex justify-content-between justify-content-lg-endn  mt-2'>
                                <button className='btn bg-primary-subtle text-primary  border-0 fw-bold '
                                    onClick={() => setShow(false)}><i class="uil uil-arrow-left"></i>  Volver </button>
                            </div>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalWarehouses